import React, {useEffect, useState} from 'react';
//import {goToPage, resetCgIframeUrl} from '../touristESimBlockSlice';
import {connect} from 'react-redux';
// import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import Payment from './Payment/Payment';
import {cgTypeEnum, cgMidTypeEnum} from '../../../utilities/enums/cgTypeEnum';
import SuccessMsg from './SuccessMsg/SuccessMsg';
import ErrorMsg from './ErrorMsg/ErrorMsg';
import PopUpPaymentError from './PopUpPaymentError/PopUpPaymentError';
import ProviderManager from './../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from '../Loader/LoaderSlice';
import {getRecaptchaToken} from '../../../utilities/recaptcha/recaptcha';
import Config from '../../../Config';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';

const CGPayment = (props) => {
  const [isDisplayErrorPopup, setIsDisplayErrorPopup] = useState(false);
  const [errorPopupContent, setErrorPopupContent] = useState('');
  const [step, setStep] = useState('payment');
  const [iframeUrl, setIframeUrl] = useState('');

  useEffect(() => {
    getCgUrl();
  }, []);
  //page params
  let btnText = 'אישור תשלום';
  let totalPrice = null;
  let priceText = '';
  let formid = 'touristESim';
  var handler;

  let currentPageView = (
    <div>
      <div className='title'>פרטי אשראי</div>
      {step == 'payment' && <Payment iframeUrl={iframeUrl} />}
      {step == 'success' && (
        <SuccessMsg
          termsLink={
            props.termsLink
          } /*isDisplayCheckboxErrorMsg={isDisplayCheckboxErrorMsg} onClickTermsCheckbox={onClickTermsCheckbox} isTermsCheckboxChecked={isTermsCheckboxChecked}*/
        />
      )}
      {step == 'error' && <ErrorMsg onclickTryAgainBtn={getCgUrl} />}
      <PopUpPaymentError
        isDisplayErrorPopup={isDisplayErrorPopup}
        content={errorPopupContent}
        closePopUp={closePopUp}
        onclickTryAgainBtn={onclickTryAgainBtn}
      />
    </div>
  );
  return (
    <div className='slideAnimation'>
      <div>
        <div className='payment'>
          <div>{currentPageView}</div>
        </div>
      </div>
    </div>
  );

  async function getCgUrl() {
    setStep('payment');
    getEMVStep1();
    addEventListener();
  }
  async function getEMVStep1() {
    const captchaToken = await getRecaptchaToken('CGPayment');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }
    showAppLoader();
    try {
      let totalPrice = props.totalPrice && props.totalPrice != '' ? props.totalPrice : '0';
      const type = cgTypeEnum.CHECKCARD;
      let customerId = '0';

      // if (Config.cgShowIdNumber == 'True' && state.personalInfo.identity) {
      //   customerId = state.personalInfo.identity;
      // }

      const result = await ProviderManager.getProviderData('getCGEMVStep1', [type, customerId, totalPrice, '1', props.cgMidType, false, props.source || 'unknown']);
      setIframeUrl(result.Body.paymentCGUrl);
      //return result.Body;
    } catch (error) {
      console.info('getCGEMVStep1', error);
      return null;
    } finally {
      hideAppLoader();
    }
  }
  async function getEMVStep2(token, identity) {
    const captchaToken = await getRecaptchaToken('CGPayment2');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }
    try {
      const totalPrice = props.totalPrice && props.totalPrice != '' ? props.totalPrice : '100';
      const blockId = 0;
      const isShowIdNumber = Config.cgShowIdNumber;
      const type = cgTypeEnum.CHECKCARD;
      let customerId = 12; //data.id;
      const result = await ProviderManager.getProviderData('getCGEMVStep2', [
        totalPrice,
        token,
        type,
        isShowIdNumber,
        customerId,
        blockId,
        props.cgMidType,
        false,
        props.source || 'unknown',
      ]);
      props.setPaymentInfo({
        authNumber: result.Body.authNumber,
        cardMonth: result.Body.cardMonth,
        cardYear: result.Body.cardYear,
        ccType: result.Body.ccType,
        credit4Digits: result.Body.credit4Digits,
        cvv: result.Body.cvv,
        id: result.Body.id,
        returnCode: result.Body.returnCode,
        totalPayments: result.Body.totalPayments,
        token: token,
      });
      props.handleResult(result.Body);
      return result.Body;
    } catch (error) {
      return error;
    }
  }
  function onclickTryAgainBtn() {
    getCgUrl();
    setIsDisplayErrorPopup(false);
  }
  function closePopUp() {
    setIsDisplayErrorPopup(false);
  }

  async function getCgConfirmation(token, identity) {
    const result = await getEMVStep2(token, identity);
    if (result.returnCode == '00') {
      setStep('success');
    } else {
      setStep('error');
    }
  }
  function addEventListener() {
    //listen to iframe messages from cg
    var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';

    handler = function (e) {
      var isSuccess = e.data.status == 'success';
      var isError = e.data.status == 'error';

      if (isSuccess) {
        // props.resetCgIframeUrl();
        if (Config.cgShowIdNumber == 'True' && props.identity != '' && e.data.personalId != props.identity) {
          setErrorPopupContent('תעודת הזהות שהזנתם לא תואמת לפרטים איתם הזדהתם בתחילת התהליך.');
          setIsDisplayErrorPopup(true);
        } else {
          getCgConfirmation(e.data.token, e.data.personalId);
        }
        removeListener();
      } else if (isError) {
        //  props.resetCgIframeUrl();
        setErrorPopupContent('האשראי שהוזן לא תואם לבעל תעודת זהות או שהזנתם מספר כרטיס אשראי שגוי.');
        setIsDisplayErrorPopup(true);
        removeListener();
        //props.reportDWH({actionType: 'Credit Card Info', status: 'Ongoing', messageText: 'Credit Guard Error'});
      }
      return;
    };

    eventer(messageEvent, handler);
  }

  function removeListener() {
    var cond = window.addEventListener;
    window[cond ? 'removeEventListener' : 'detachEvent'](cond ? 'message' : 'onmessage', handler);
  }
};

export default CGPayment;
